"use client";

import { useTranslations } from "next-intl";
import FaqAccordion from "./faq-accordion";

export default function Profil() {
    const t = useTranslations("helpContent");

    return (
        <FaqAccordion
            items={[
                {
                    question: t("profileQ1"),
                    answer: (
                        <>
                            <p>{t("profileA1")}</p>
                            <ul className="mt-2 list-disc pl-5">
                                <li>{t("profileA1Step1")}</li>
                                <li>{t("profileA1Step2")}</li>
                                <li>{t("profileA1Step3")}</li>
                            </ul>
                        </>
                    ),
                },
            ]}
        />
    );
}
